"use client"

import { usePathname, useRouter } from "next/navigation"
import React, { useEffect } from "react"

import { scroller } from "@/hooks/useScroll"
import SubNav from "@/ui/patterns/SubNav"

import Button from "../../Button"

const SwellNav: React.FC<any> = () => {
  const router = useRouter()
  const pathName = usePathname()
  useEffect(() => {
    const currentHash = window.location.hash.replace("#", "")
    if (currentHash) {
      scroller.scrollTo(currentHash, {
        smooth: true,
        duration: 500,
        offset: 600, // Adjust based on your header size
      })
    }
  }, [])
  const parentLink = "Swell"
  const menuLinks = [
    {
      text: "Overview",
      location: "/events/swell/",
    },
    {
      text: "Speakers",
      location: "/events/swell/speakers/",
    },
    {
      text: "Venue",
      location: "/events/swell#venue",
      onClick: () => {
        const path = "/events/swell/"
        const hash = "venue"
        // Set the hash to scroll to after navigation
        if (pathName === path) {
          // Already on the page, scroll directly
          scroller.scrollTo(hash, {
            smooth: true,
            duration: 500,
          })
        } else {
          // Navigate to the page with the hash in the URL
          router.push(`/events/swell#${hash}`)
        }
      },
    },
    {
      text: "FAQ",
      location: "/events/swell/faq/",
    },
  ]

  const subnavCtaButton = (
    <Button
      to="https://register.ripple.com/swell2025registration/begin/"
      className="block mb-4 lg:mr-4 lg:mb-0 register-now"
    >
      Request Your Invite
    </Button>
  )

  return (
    <SubNav
      parentLink={parentLink}
      menuLinks={menuLinks}
      mode="dark"
      ctaButton={subnavCtaButton}
    />
  )
}

export default SwellNav
